module.exports = __webpack_public_path__ + "img/new-guide-img1.b628d9a9.png";